import React from 'react';
import Step from '@mui/material/Step';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';

const CustomStep = withStyles({
  root: {
    paddingRight: '0 !important',
    paddingLeft: '0 !important',
  },
})(Step);

const UiStep = (props) => {
  const { children, className, ...restProps } = props;
  return (
    <CustomStep className={className} {...restProps}>
      {children}
    </CustomStep>
  );
};

UiStep.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default UiStep;
